import { render, staticRenderFns } from "./ServicesRetailEvent.vue?vue&type=template&id=8a2653a2&scoped=true&"
import script from "./ServicesRetailEvent.vue?vue&type=script&lang=js&"
export * from "./ServicesRetailEvent.vue?vue&type=script&lang=js&"
import style0 from "./ServicesRetailEvent.vue?vue&type=style&index=0&id=8a2653a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2653a2",
  null
  
)

export default component.exports